import * as Sentry from '@sentry/react'

import appSentryBrowserOptions from './browserOptions'
import { setHeaderSentry } from './headerSentry'

/*
 * This function gets the Sentry hub set by the header app and then stores it, so errors for the header can be redirected there.
 * A Sentry hub for the running application is then created and set to be the default, with errors for the header redirected
 * automatically to the header app's Sentry hub.
 *
 * For HeadBox purposes, there is one Sentry hub for the running app and one Sentry hub for the header.
 */

const setupAppSentry = (): void => {
  /*
   * Store a copy of the Sentry hub from the header - if the header has logging enabled, this will be stored, otherwise it will be stored as null and effectively ignored.
   * This is only a best effort as the assumption made is that the header app will initalise Sentry first. This seems to work in most cases however.
   */
  setHeaderSentry(Sentry.getCurrentHub())

  /*
   * Create a Sentry hub for the running app and set it to be the default. The passed in options will redirect header errors to the header app's
   * Sentry hub so the header app can log them as header errors, correctly.
   */
  Sentry.init(appSentryBrowserOptions)
}

export default setupAppSentry
